import {get as _get, isNil as _isNil} from 'lodash';

export const exportExcel = (data) => ({
    dataExport: data,
    filename: 'sequence_configs',
    path: 'sequenceConfigs.index.path',
    titles: [
        'ID',
        'Name',
        'Data source',
        'Start delay',
        'Stop delay',
        'Cutoff',
    ],
    parseData: sequence => [
        sequence.id,
        sequence.name,
        _get(sequence, 'sequence_data_source.name', ''),
        !_isNil(sequence.start_delay) ? `${sequence.start_delay}s` : '',
        !_isNil(sequence.stop_delay) ? `${sequence.stop_delay}s` : '',
        !_isNil(sequence.cutoff) ? `${sequence.cutoff} min` : '',
    ],
});
